var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "account-manage-companies-list" },
    _vm._l(_vm.accounts, function (account) {
      return _c("row", {
        key: account.id,
        attrs: {
          account: account,
          "is-current-account": _vm.isCurrentAccount(account),
          "current-user-is-admin": _vm.currentUserIsAdmin,
          "is-assigned-to-current-user": _vm.isAssignedToCurrentUser(account),
        },
        on: {
          edit: function ($event) {
            return _vm.edit(account)
          },
          assignments: function ($event) {
            return _vm.assignments(account)
          },
          drop: function ($event) {
            return _vm.drop(account)
          },
          editLogo: function ($event) {
            return _vm.editLogo(account)
          },
          editPrimaryContact: function ($event) {
            return _vm.editPrimaryContact(account)
          },
          hotelDirectory: function ($event) {
            return _vm.hotelDirectory(account)
          },
          rateLoadingInformation: function ($event) {
            return _vm.rateLoadingInformation(account)
          },
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }